import { createTheme } from '@mui/material/styles';
import type {} from '@mui/x-data-grid/themeAugmentation';

export const coal = '#28363A';
export const coal80 = '#535E61';
export const raspberry = '#BD3156';
export const raspberry80 = '#CA5A78';
export const coral = '#FF6468';
export const coral80 = '#FF8389';
export const whitish = '#F1F3F4';
export const lightGrey = '#dbdada';

export const themeOptions = createTheme({
  components: {
    MuiCard: {
      styleOverrides: {
        root: {
          padding: 30
        }
      }
    },
    MuiDataGrid: {
      styleOverrides: {
        root: {
          '& .MuiDataGrid-cell': {
            borderColor: lightGrey,
          },
          '& .MuiDataGrid-cell:focus': {
            outline: 'none',
          },
          '& .MuiDataGrid-cellContent:hover': {
            overflow: 'visible',
            marginRight: 30,
            position: 'absolute',
            backgroundColor: '#f5f5f5',
            color: coral,
            paddingRight: 5
          },
          '& .MuiDataGrid-row.Mui-selected .MuiDataGrid-cell .MuiDataGrid-cellContent:hover': {
            backgroundColor: '#f2d5dd',
          },
          '& .MuiDataGrid-columnHeaders': {
            color: raspberry,
            borderColor: coal80
          },
        }
      }
    },
    MuiDrawer: {
      styleOverrides: {
        root: {
          '& .MuiDrawer-paper': {
            backgroundColor: whitish,
          }
        }
      }
    }
  },
  palette: {
    mode: 'light',
    primary: {
      main: raspberry,
      contrastText: whitish,
      dark: coral,
      light: raspberry80,
    },
    secondary: {
      main: coral,
      light: coral80,
      dark: raspberry,
      contrastText: whitish,
    },
    background: {
      default: whitish,
    },
    text: {
      primary: coal,
      secondary: coal80,
      disabled: lightGrey,
    },
    divider: lightGrey,
  },
  shape: {
    borderRadius: 12,
  },
  typography: {
    h2: {
      fontWeight: 1000,
    },
    button: {
      fontWeight: 800,
    },
  },
});

// export const themeOptionsDark = createTheme({
//     components: {
//         MuiCard: {
//             styleOverrides: {
//                 root: {
//                     padding: 30
//                 }
//             }
//         },
//         MuiDataGrid: {
//             styleOverrides: {
//                 root: {
//                     '& .MuiDataGrid-cell': {
//                         borderColor: lightGrey,
//                         // border: "1px solid" + lightGrey
//                     },
//                     "& .MuiDataGrid-columnHeaders": {
//                         color: raspberry,
//                         borderColor: coal80
//                         // border: "1px solid" + lightGrey
//                     },
//
//                 }
//             }
//         }
//     },
//     palette: {
//         mode: 'dark',
//         primary: {
//             main: raspberry,
//             contrastText: whitish,
//             dark: coral,
//             light: raspberry80,
//         },
//         secondary: {
//             main: coral,
//             light: coral80,
//             dark: raspberry,
//             contrastText: whitish,
//         },
//         background: {
//             default: coal,
//         },
//         text: {
//             primary: coal,
//             secondary: coal80,
//             disabled: lightGrey,
//         },
//         divider: lightGrey,
//     },
//     shape: {
//         borderRadius: 12,
//     },
//     typography: {
//         h2: {
//             fontWeight: 1000,
//         },
//         button: {
//             fontWeight: 800,
//         },
//     },
// });
